import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(i, e) {
  return o(), t("svg", l, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M19.059 12A7.059 7.059 0 1 0 12 19.059V20a8 8 0 1 1 0-16 8 8 0 0 1 0 16v-.941A7.06 7.06 0 0 0 19.059 12"
    }, null, -1),
    n("path", {
      fill: "currentColor",
      d: "M12.47 11.53v4.705h-.94V11.53zm0-3.765v1.882h-.94V7.765z"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
